import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-conversation-detail',
  templateUrl: './conversation-detail.component.html',
  styleUrls: ['./conversation-detail.component.css']
})
export class ConversationDetailComponent implements OnChanges, OnDestroy {
  @Input() conversacion: any; // Recibe la conversación desde el componente padre
  mensajes: any[] = []; // Almacena los mensajes de la conversación
  mensajeForm: FormGroup; // Formulario reactivo para enviar mensajes
  private subscription: Subscription | null = null;

  constructor(
    private notificationService: NotificationService,
    private dataService: DataService,
    private fb: FormBuilder
  ) {
    // Inicializar el formulario reactivo
    this.mensajeForm = this.fb.group({
      mensaje: ['', [Validators.required, Validators.minLength(1)]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['conversacion'] && this.conversacion) {
      this.cargarMensajes();
      this.escucharNotificaciones();
    }
  }

  ngOnDestroy() {
    // Desuscribirse de notificaciones al destruir el componente
    this.subscription?.unsubscribe();
  }

  cargarMensajes() {
    const { contactoId } = this.conversacion;
    this.dataService.getData(`conversaciones/${contactoId}`, environment.apiMensajeUrl).subscribe({
      next: (mensajes) => {
        this.mensajes = mensajes.map((m: any) => ({
          texto: m.contenido,
          esRemitente: m.remitenteId === this.conversacion.contactoId,
          fecha: new Date(m.fecha)
        }));
      },
      error: (err) => console.error('Error cargando mensajes:', err)
    });
  }

  enviarMensaje() {
    if (this.mensajeForm.invalid) {
      return;
    }

    const nuevoMensaje = this.mensajeForm.value.mensaje;

    const mensaje = {
      contenido: nuevoMensaje,
      remitenteId: this.conversacion.usuarioId,
      destinatarioId: this.conversacion.contactoId
    };

    this.dataService.postData(mensaje, 'mensajes', environment.apiMensajeUrl).subscribe({
      next: () => {
        this.mensajes.push({
          texto: nuevoMensaje,
          esRemitente: false,
          fecha: new Date()
        });
        this.mensajeForm.reset(); // Limpiar el formulario
      },
      error: (err) => console.error('Error enviando mensaje:', err)
    });
  }

  escucharNotificaciones() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.notificationService.receivedMessage$.subscribe((mensaje) => {
      if (
        mensaje?.remitenteId === this.conversacion?.contactoId &&
        mensaje?.destinatarioId === this.conversacion?.usuarioId
      ) {
        this.mensajes.push({
          texto: mensaje.contenido,
          esRemitente: false,
          fecha: new Date(mensaje.fecha)
        });
      }
    });
  }
}
